import React, { useState, useEffect } from "react";
import axios from "axios";
import { useHistory, Link, useParams } from "react-router-dom";
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { Button, Card } from '@mui/material';
import FileUploader from "../../FileUploader";
import { endpoints } from "../../../services/apiurl";
import Input from "../../UI/Input/Input";
import PageTitle from "../../UI/PageTitle";
import LoadingButton from '@mui/lab/LoadingButton';
import SaveIcon from '@mui/icons-material/Save';


const Addamenities = () => {
    let history = useHistory();
    const [cat, setCat] = useState({
        name: '',
        // icon: '',
        status: '',
        restro_id: '',
    });
    const [selectedFile, setSelectedFile] = useState(null);

    const handleFileSelectSuccess = (file) => {
        setSelectedFile(file);
      };
    
      const handleFileSelectError = ({ error }) => {
        alert(error);
      };
    const [loading, setloading] = useState(false);
    const [rest, setRest] = useState([]);


    const { name, status, restro_id } = cat;
    const onInputChange = (e) => {
        const inputValue = e.target.value;
        const inputName = e.target.name;
    
        if (inputName === 'name') {
            // Check for special characters
            const disallowedCharacters = /[#$%^&*0-9!@#$%^&*()+=\[\]{}:\\|<>\?]+/;
            if (disallowedCharacters.test(inputValue)) {
                alert('Special characters are not allowed in the Name field');
                return;
            }
    
            
            if (/^\s+$/.test(inputValue)) {
                alert('Input cannot be only blank spaces');
                return;
            }
        }
    
        // Update the state for all other inputs
        setCat({ ...cat, [inputName]: inputValue });
    };
    
    

    useEffect(() => {
        getRestaurentsDropDown();
    }, []);


    const getRestaurentsDropDown = async () => {
        await axios.post(endpoints.getRestaurentsDropDown).then((response) => {
            setRest(response.data.data);
        });
    };

    const onSubmit = async (e) => {
        setloading(true);
        e.preventDefault();
        
        if (!selectedFile) {
            alert('Please select an image');
            setloading(false);  // Set loader to false when there's an alert
            return false;
        }
    
        const formData = new FormData();
        formData.append("name", name);
        formData.append("restro_id", restro_id);
        formData.append("image", selectedFile);
        formData.append("status", status);
    
        try {
            const response = await axios.post(endpoints.addRestaurentsAmenities, formData);
            setloading(false);  // Set loader to false on successful API call
            history.goBack();
        } catch (error) {
            console.error('Error:', error);
            alert('An error occurred while saving. Please try again.');
            setloading(false);  // Set loader to false on API call failure
        }

        
    };


    
    return (
        <div className="ui main">
            <PageTitle title="Add Amenities" linkurl="" linkTitle="" />

            <Card className="px-3 py-3">
                <form className="ui form" onSubmit={e => onSubmit(e)} encType="multipart/form-data">
                    <div className="row">
                        <div className="col col-6">
                            <label>Restaurents </label>
                            <select name="restro_id" required className="form-control" onChange={e => onInputChange(e)} >
                                <option value="">Select Restaurents</option>
                                {rest.map((e, key) => {
                                    return <option key={key} value={e.id}>{e.name}</option>;
                                })}
                            </select>
                        </div>

                        <Input id="name" label="Name" type="text" name="name" place="Name" onChange={(e) => onInputChange(e)}
                            requiredInput="required" value={name} class="col col-6"
                        />


                    </div>

                    <div className="row">
                        <div className="col col-6">
                            <label>Status</label>
                            <select name="status" required className="form-control" onChange={e => onInputChange(e)} >
                                <option value="">Select Status</option>
                                <option value="2">InActive</option>
                                <option value="1">Active</option>
                            </select>
                        </div>

                    </div>

                    <div className="row">
                        <div className="col col-6">
                            <label>Image</label>
                            <FileUploader
        onFileSelectSuccess={handleFileSelectSuccess}
        onFileSelectError={handleFileSelectError}
      />

      {selectedFile && (
        <div>
          <p>Preview:</p>
          <img
            src={URL.createObjectURL(selectedFile)}
            alt="Selected Logo"
            height="200px" width="200px"
          />
        </div>
      )}
                        </div>
                    </div>

                    <div className="row">
                        <div className="col col-6">
                            <div className="mt-3">
                                <LoadingButton
                                    type="submit"
                                    loading={loading}
                                    loadingPosition="start"
                                    startIcon={<SaveIcon />}
                                    variant="contained"
                                    size="large"
                                >
                                    Save
                                </LoadingButton>
                            </div></div></div>


                </form>
            </Card>
        </div>
    );

}

export default Addamenities;


